import { Routes } from '@angular/router';
import {
  BreadCrumbRouteConfig,
  RenderInterfaceGuard,
  Utils
} from 'viggo-sistemas-core-web';

export const routesAdminParametrizacao: Routes = [
  {
    path: 'porcao-tipo',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@app/modules/porcao-tipo/porcao-tipo.module').then(
        m => m.PorcaoTipoModule
      ),
    data: {
      module: 'PORCAO_TIPO',
      breadcrumb: {
        label: 'Tipos de porção',
        icon: 'pi pi-fw pi-book'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'encartes_promocao',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@app/modules/encartes_promocao/encartes_promocao.module').then(
        m => m.EncartesPromocaoModule
      ),
    data: {
      module: 'ENCARTE_PROMOCAO',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES','PRODUTO'),
      breadcrumb: {
        label: 'Encarte de promoção',
        icon: 'mdi mdi-store-clock-outline'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'porcao',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@app/modules/porcao/porcao.module').then(m => m.PorcaoModule),
    data: {
      module: 'PORCAO',
      breadcrumb: {
        label: 'Porção',
        icon: 'pi pi-fw pi-book'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'cardapio-item',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@app/modules/cardapio-item/cardapio-item.module').then(
        ({ CardapioItemModule }) => CardapioItemModule
      ),

    data: {
      module: 'CARDAPIO_ITEM',
      breadcrumb: {
        label: 'Cardapio item',
        icon: 'pi pi-fw pi-book'
      }
    }
  },
  {
    path: 'relatorio',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'RELATORIO',
      backend_path: '/pedidos'
    },
    loadChildren: () =>
      import('@app/modules/report/report.module').then(m => m.ReportModule)
  },
  {
    path: 'tags',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'TAG',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CADASTROS'),
      preload: false,
      breadcrumb: {
        label: 'Tags',
        icon: 'pi pi-fw pi-cog'
      },
      backend_path: '/tags'
    },
    loadChildren: () =>
      import('@app/modules/tags/tags.module').then(m => m.TagsModule)
  }
];
